import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { UraniumConsensusResult } from "../Types/types";

const LOCAL_API_URL = `http://localhost:7089/api/GetUraniumStocksFunction`;
const API_URL =
  process.env.NODE_ENV === "development"
    ? LOCAL_API_URL
    : process.env.REACT_APP_API_URL;

export function useConsensusData() {
  const [data, setData] = useState<UraniumConsensusResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const apiKey = process.env.REACT_APP_FUNCTION_KEY;
      const fullUrl = `${API_URL}?code=${apiKey}`;
      const { data } = await axios.get<UraniumConsensusResult>(fullUrl);
      setData(data);
      setError(null);
    } catch (err: any) {
      console.error(err);
      setError(err.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, error, loading };
}